import React from 'react';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { useDispatch } from 'react-redux';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { PortfolioReportForm } from './components/PortfolioReportForm/PortfolioReportForm';
import { resetState } from './state';
import { GenerateReport } from './components/GenerateReport/GenerateReport';
import { useGenerateReportMutation } from './api/useGenerateReportMutation';
import { ErrorAlert } from './components/ErrorAlert/ErrorAlert';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

export const PortfolioReports: React.FC = () => {
  const {
    mutateAsync: generateReport,
    isLoading,
    isError,
    error,
    reset,
  } = useGenerateReportMutation();

  const dispatch = useDispatch();

  useEffectOnce(() => () => {
    dispatch(resetState());
  });

  useDocumentTitle('Reports - Portfolio Reports');

  return (
    <Box display="flex" flexDirection="column" minWidth={500} height="100%" mx={-30} px={30}>
      {isError && (
        <Box width={490} mb="32">
          <ErrorAlert error={error} onRequestClose={reset} />
        </Box>
      )}

      <Text as="h1" fontSize="h5" fontWeight={500} mb="4">
        Portfolio Reports
      </Text>
      <Text fontSize="small" color="neutral.500">
        Select a report to run
      </Text>

      <PortfolioReportForm />

      <GenerateReport isLoading={isLoading} generateReport={generateReport} mt="24" />
    </Box>
  );
};
